<template>
  <div>
    <!-- HESAP BİLGİLERİ BİLGİLERİ -->

    <div class="vx-row w-full" style="margin-bottom: 39px;justify-content: center;margin-top: 52px;font-size: xx-large;">
      <label>Müşteri Hesap Bilgieri</label>
    </div>

    <div class="vx-row w-full" style="margin-left:5px;margin-bottom: 39px;justify-content: left;margin-top: 52px;font-size: x-large;">
      <a :href="'/contactsView/' + $route.params.customerId" style="margin-left: 15px; margin-top: 5px; color: orange;" target="_blank">{{ "Hesap Sahibi : " + accountList[0].accountName }}</a>

      <a class="danger"
        href="#"
        @click.stop="
          reconcilePopupParent = true;
          customerIdPropParent = accountList[0].customerId;
        "
        style="margin-left: 15px; margin-top: 5px; "
        ><b>Reconcile</b></a
      >
      <reconcile v-if="reconcilePopupParent" :reconcilePopupProp="reconcilePopupParent" :customerIdProp="customerIdPropParent" @ReconcilePopupClosedChildEmit="ReconcilePopupClosedParentEmitCatch($event)"></reconcile>
    </div>

    <!-- <div class="vx-row w-full" style="margin-bottom: 39px;justify-content: center;font-size: large;">
      Fiş Bilgileri :<strong style="color :blue; animation: blink 0.02s 20 alternate"> {{ accountList[0].transactionDescription }} </strong>
    </div> -->
    <div style="width:100%">
      <div class="vx-row">
        <div class="vx-col  md:w-1/12 w-full" style="display:flex;height: min-content;">
          <label class="vs-input--label">Hesap No</label>
        </div>
        <div class="vx-col  md:w-1/12 w-full" style="display:flex;height: min-content;">
          <label class="vs-input--label">Hesap Adı ve Türü</label>
        </div>

        <div class="vx-col  md:w-1/12 w-full" style="display:flex;height: min-content;">
          <label class="vs-input--label">Toplam Borç Hareketi</label>
        </div>
        <div class="vx-col  md:w-1/12 w-full" style="display:flex;height: min-content;">
          <label class="vs-input--label">Toplam Alacak Hareketi</label>
        </div>
        <div class="vx-col  md:w-1/12 w-full" style="display:flex;height: min-content;">
          <label class="vs-input--label"><strong>Bakiye</strong></label>
        </div>
      </div>
    </div>

    <div :key="i" v-for="(tr, i) in accountList" style="width:100%">
      <div class="vx-row">
        <div class="vx-col md:w-1/12 w-full" style="display:flex;height: min-content;">
          <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.accountId" type="number" name="hesapno" />
        </div>
        <div class="vx-col md:w-1/12 w-full" style="display:flex;height: min-content;">
          <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.accountDescription" type="text" name="accountName" />
        </div>
        <div class="vx-col md:w-1/12 w-full" style="display:flex;height: min-content;">
          <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.sumOfOwedAmount" type="number" name="sumOfOwedAmount" />
        </div>
        <div class="vx-col md:w-1/12 w-full" style="display:flex;height: min-content;">
          <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.sumOfOwedToAmount" type="number" name="sumOfOwedToAmount" />
        </div>
        <div class="vx-col md:w-1/12 w-full" style="display:flex;height: min-content;">
          <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.balance" type="number" name="Bakiye" />
        </div>
        <div class="vx-col md:w-2/12 w-full mt-3" style="display:flex">
          <vs-button class="mr-4 mb-4" @click="$router.push('../AccountMovementWatch/' + tr.accountId)">Hesap Hareketlerini İzle</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";
import Reconcile from "../Account/Reconcile";

export default {
  components: {
    vSelect,
    Reconcile,
  },
  data() {
    return {
      reconcilePopupParent: false,
      customerIdPropParent: false,
      accountList: [{ accountName: null, transactionDescription: null }],
    };
  },
  watch: {},
  computed: {},

  methods: {
    ReconcilePopupClosedParentEmitCatch: async function(v) {
      this.reconcilePopupParent = false;
      console.log("reconcile child is closed", v);
      this.$vs.loading();
      await this.getAccountList();
      this.$vs.loading.close();
    },
    getAccountList: async function() {
      this.accountList = await repository.postEntity("Accounting/getAccount", { customerId: this.$route.params.customerId }).then((r) => r.list);
    },
  },
  created: async function() {
    this.$vs.loading();
    if (this.$route.params != null && this.$route.params.customerId > 0) {
      await Promise.all([this.getAccountList()]);
    }
    this.$vs.loading.close();
  },
};
</script>
